// extracted by mini-css-extract-plugin
module.exports = {"form":"PasswordReset__form__xkH3E"};